export const HIGHLIGHT_COLORS = [
  {
    id: "yellow",
    labelZh: "琥珀黄",
    labelEn: "Amber Gold",
    dotColor: "#eab308",
    bgLight: "rgba(250, 204, 21, 0.22)",
    bgDark: "rgba(250, 204, 21, 0.18)",
    borderLight: "#eab308",
    borderDark: "#facc15",
  },
  {
    id: "green",
    labelZh: "灵修绿",
    labelEn: "Meadow Green",
    dotColor: "#22c55e",
    bgLight: "rgba(74, 222, 128, 0.22)",
    bgDark: "rgba(74, 222, 128, 0.18)",
    borderLight: "#22c55e",
    borderDark: "#4ade80",
  },
  {
    id: "blue",
    labelZh: "恩典蓝",
    labelEn: "Grace Blue",
    dotColor: "#3b82f6",
    bgLight: "rgba(96, 165, 250, 0.22)",
    bgDark: "rgba(96, 165, 250, 0.18)",
    borderLight: "#3b82f6",
    borderDark: "#60a5fa",
  },
  {
    id: "pink",
    labelZh: "玫瑰粉",
    labelEn: "Rose Pink",
    dotColor: "#ec4899",
    bgLight: "rgba(244, 114, 182, 0.22)",
    bgDark: "rgba(244, 114, 182, 0.18)",
    borderLight: "#ec4899",
    borderDark: "#f472b6",
  },
  {
    id: "purple",
    labelZh: "薰衣紫",
    labelEn: "Lavender",
    dotColor: "#a855f7",
    bgLight: "rgba(192, 132, 252, 0.22)",
    bgDark: "rgba(192, 132, 252, 0.18)",
    borderLight: "#a855f7",
    borderDark: "#c084fc",
  },
];

const STORAGE_KEY = "bible-verse-highlights";

const readAllHighlights = () => {
  try {
    const raw = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
};

const writeAllHighlights = (data) => {
  try {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    }
  } catch (e) {}
};

export const loadChapterHighlights = (chapterId) => {
  if (!chapterId) return {};
  const all = readAllHighlights();
  return all[String(chapterId)] || {};
};

export const setRangeHighlights = (chapterId, startVerse, endVerse, colorId) => {
  if (!chapterId || startVerse == null || endVerse == null) return {};
  const min = Math.min(Number(startVerse), Number(endVerse));
  const max = Math.max(Number(startVerse), Number(endVerse));
  const all = readAllHighlights();
  const cId = String(chapterId);
  const chapterData = { ...(all[cId] || {}) };

  for (let i = min; i <= max; i++) {
    if (colorId) {
      chapterData[String(i)] = colorId;
    } else {
      delete chapterData[String(i)];
    }
  }

  if (Object.keys(chapterData).length === 0) {
    delete all[cId];
  } else {
    all[cId] = chapterData;
  }

  writeAllHighlights(all);
  return chapterData;
};

export const getHighlightStyle = (colorId, isDark) => {
  if (!colorId) return null;
  const item = HIGHLIGHT_COLORS.find((c) => c.id === colorId);
  if (!item) return null;
  return {
    backgroundColor: isDark ? item.bgDark : item.bgLight,
    borderLeft: `3px solid ${isDark ? item.borderDark : item.borderLight}`,
  };
};
